var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",style:({ backgroundColor: _vm.bgColor }),on:{"touchmove":function($event){$event.preventDefault();}}},[_c('svg-btn',{staticClass:"icon",attrs:{"icon-class":"icon-short-hclose"},on:{"click":_vm.toBack}}),_c('span',{staticClass:"head"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }